export function getFileNameFromUrl(url?: string): string | null {
    if (!url) return null;
    return url.split('/').pop() || 'archivo.pdf';
}

export function isPdfFile(file: File): boolean {
    return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
}
